import React from 'react'

const ApprovalConfirmedTemplate = ({ data }) => {
  const {
    studentName,
    roleName,
    companyName,
    placementOfficerName,
    placementOfficerContact
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Hi {studentName},</p>
      
      <p style={{ paddingTop: '8px' }}>
        Your request to apply for the {roleName} role at {companyName} has been approved. 
        As per the process, your application for this role has now been automatically confirmed.
      </p>
      
      <p style={{ paddingTop: '8px' }}>
        No further action is required from your end. If you have any questions or need assistance, 
        feel free to reach out.
      </p>
      
      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{placementOfficerName}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{placementOfficerContact}</p>
    </div>
  )
}

export default ApprovalConfirmedTemplate
